<div (dblclick)="dblclick($event)" class="current-title">{{title}}</div>
<div (dblclick)="dblclick($event)" class="content">
  <ng-content *ngIf="visible"></ng-content>
</div>
